import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { technologicalTransferMembershipOptions } from '@/module/Nomen/TechnologicalTransferMembership/model/TechnologicalTransferMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type TechnologicalTransferMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function TechnologicalTransferMembershipSelectControl<T extends FieldValues>(
  props: TechnologicalTransferMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(technologicalTransferMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
